import IconWrapper, { IconWrapperProps } from "../IconWrapper";

type ChevronRightProps = Pick<IconWrapperProps, "className">;

const ChevronRight = (props: ChevronRightProps) => {
  return (
    <IconWrapper width={24} height={24} {...props}>
      <path
        fill="currentColor"
        d="M5.59 7.41L7 6l6 6l-6 6l-1.41-1.41L10.17 12zm6 0L13 6l6 6l-6 6l-1.41-1.41L16.17 12z"
      />
    </IconWrapper>
  );
};

export default ChevronRight;
